<template>
  <formsTemplate>
    <v-form ref="form" v-model="valid" lazy-validation>
      <p class="font-weight-bold text-body-1 text-center">
        {{ $t("recoveryView.recoveryPassword") }}
      </p>
      <p class="text-body-1 text-center mt-2 mb-10">
        {{ $t("recoveryView.btreeAccount") }}
      </p>
      <p class="font-weight-bold text-body-1">{{ $t("recoveryView.email") }}</p>
      <v-text-field
        solo
        v-model="email"
        hide-details="auto"
        @keydown.enter="logar"
        :rules="[rules.required, rules.email]"
        flat
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
      </v-text-field>

      <div class="d-flex justify-space-between mt-6">
        <v-btn
          color="secondary"
          class="primary--text"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :to="{ name: 'login', query: $route.query }"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("recoveryView.cancel") }}
          </p>
        </v-btn>
        <v-btn
          color="success"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :loading="status === 'LOADING-PASSWORD'"
          @click="logar"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("recoveryView.send") }}
          </p>
        </v-btn>
      </div>
    </v-form>
  </formsTemplate>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { rules } from "@/mixins/rules";
import formsTemplate from "@/components/formsTemplate.vue";
export default {
  components: {
    formsTemplate,
  },
  data: () => ({
    email: "",
    rules,
    valid: false,
  }),
  computed: {
    ...mapState(useAuthStore, ["status"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["recoveryPassword"]),

    async logar() {
      await this.$refs.form.validate();
      if (this.valid) this.recoveryPassword(this.email);
    },
  },
};
</script>
<style scoped>
.m-auto {
  margin-left: auto;
  margin-right: auto;
}
::v-deep .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #252831;
}
</style>
